var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndToEnd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 83.5571V43.0054C0 18.9187 19.7878 -0.526558 44.0217 0.0108795C66.8875 0.548309 85.5515 19.2607 85.9912 42.126C86.2355 54.3404 81.3497 65.431 73.3857 73.3948C65.6172 81.1631 54.8683 86 42.9956 86H2.44293C1.12375 86 0 84.8763 0 83.5571Z",
    fill: "#00531C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1634_1911)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.1252,
    cy: 40.6584,
    r: 4.80192,
    stroke: "#EBFF00",
    strokeWidth: 1.67778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.7491,
    cy: 26.1944,
    r: 3.35556,
    stroke: "white",
    strokeWidth: 1.67778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1944,
    cy: 58.014,
    r: 3.35556,
    stroke: "white",
    strokeWidth: 1.67778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1944,
    cy: 59.1944,
    r: 3.35556,
    stroke: "white",
    strokeWidth: 1.67778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.549,
    cy: 28.3638,
    r: 2.05383,
    stroke: "white",
    strokeWidth: 1.67778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.0021,
    cy: 53.2412,
    r: 2.05383,
    stroke: "white",
    strokeWidth: 1.67778
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.5114,
    y1: 29.8474,
    x2: 40.4539,
    y2: 36.5007,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.7022,
    y1: 44.322,
    x2: 55.2522,
    y2: 51.872,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.7978,
    y1: 36.6581,
    x2: 56.7978,
    y2: 27.6581,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.9853,
    y1: 55.3144,
    x2: 40.2669,
    y2: 44.0328,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.0234,
    y1: 45.4307,
    x2: 45.0234,
    y2: 55.2659,
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1634_1911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndToEnd);
export default __webpack_public_path__ + "static/media/EndToEnd.547153756a6cdb191c129dd2a1f8fb33.svg";
export { ForwardRef as ReactComponent };